<template>
    <div>
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Aktivitas Konsul' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <div
            class="d-flex align-center justify-space-between font-weight-bold font-size-20 mt-3 mb-7"
        >
            <div>Aktivitas Konsul</div>
            <div>
                <v-chip v-if="filterParam.mapel_id" class="mr-1" small>
                    {{ mapelName(filterParam.mapel_id) }}
                </v-chip>

                <v-chip
                    v-if="filterParam.date_from && filterParam.date_to"
                    class="mr-1"
                    small
                >
                    {{ filterParam.date_from }} s/d {{ filterParam.date_to }}
                </v-chip>

                <v-btn
                    depressed
                    color="#fff"
                    class="mr-1"
                    @click="getDataActivity()"
                >
                    <v-icon class="mr-2" small>mdi-refresh</v-icon>
                    Refresh
                </v-btn>

                <v-btn depressed color="#fff" @click="dialogFilter = true">
                    <v-icon class="mr-2" small>mdi-tune-variant</v-icon>
                    Filter
                </v-btn>
            </div>
        </div>

        <consul-activity-statistic
            v-if="!loading_per_status"
            :data="data_statistic"
        />

        <loading-stat v-else class="mb-1" />

        <consul-activity-chart
            v-if="!loading_per_mapel && !loading_per_status"
            :chart-mapel="data_chart_per_mapel"
            :chart-status="data_statistic"
        />

        <loading-chart v-else class="mb-5" />

        <consul-activity-table />

        <v-dialog
            v-model="dialogFilter"
            max-width="356"
            min-height="200px"
            max-height="210px"
            scrollable
        >
            <dialog-filter-activity
                @search="
                    dialogFilter = false;
                    filterParam = $event;
                    getDataActivity();
                "
                @close="dialogFilter = false"
            />
        </v-dialog>
    </div>
</template>

<script>
import ConsulActivityTable from "./components/ConsulActivityTable.vue";
import ConsulActivityStatistic from "./components/ConsulActivityStatistic.vue";
import ConsulActivityChart from "./components/ConsulActivityChart.vue";
import DialogFilterActivity from "./components/DialogFilterActivity.vue";
import LoadingStat from "./components/LoadingStat.vue";
import LoadingChart from "./components/LoadingChart.vue";
import axios from "axios";

export default {
    name: "consul-activity",

    components: {
        ConsulActivityTable,
        ConsulActivityStatistic,
        ConsulActivityChart,
        DialogFilterActivity,
        LoadingStat,
        LoadingChart,
    },

    data() {
        return {
            loading_per_status: true,
            loading_per_mapel: true,
            data_statistic: {},
            data_chart_per_mapel: [],
            data_chart_per_status: [],
            dialogFilter: false,
            filterParam: {
                mapel_id: null,
                date_from: null,
                date_to: null,
            },
            startDate: this.$moment().startOf("year").format("YYYY-MM-DD"),
            endDate: this.$moment().endOf("year").format("YYYY-MM-DD"),
            mapelList: JSON.parse(localStorage.getItem("mapels")),
        };
    },

    watch: {},

    mounted() {
        this.getDataActivity();
    },

    methods: {
        async getDataActivity() {
            this.loading_per_status = true;
            this.loading_per_mapel = true;

            await this.delay(500);
            this.getTotalActivityPerStatus();
            this.getTotalActivityPerMapel();
        },

        getTotalActivityPerStatus() {
            const url = `${process.env.API_BASE_URL}konsul/admin/get-total-activity-status`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            const self = this;
            self.loading_per_status = true;

            self.data_statistic = [];

            var param = {
                mapel_id: self.filterParam.mapel_id || null,
                date_from: self.filterParam.date_from || self.startDate,
                date_to: self.filterParam.date_to || self.endDate,
            };

            axios
                .get(url, {
                    params: param,
                    ...options,
                })
                .then(function (response) {
                    self.data_statistic = response.data;
                })
                .finally(() => {
                    self.loading_per_status = false;
                });
        },

        getTotalActivityPerMapel() {
            const url = `${process.env.API_BASE_URL}konsul/admin/get-total-activity-per-mapel`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            const self = this;
            self.loading_per_mapel = true;

            self.data_chart_per_mapel = [];

            var param = {
                mapel_id: self.filterParam.mapel_id || null,
                date_from: self.filterParam.date_from || self.startDate,
                date_to: self.filterParam.date_to || self.endDate,
            };

            axios
                .get(url, {
                    params: param,
                    ...options,
                })
                .then(function (response) {
                    var res = response.data;
                    var mapel_id = self.filterParam.mapel_id;

                    if (mapel_id) {
                        mapel_id = self.filterParam.mapel_id
                            .toString()
                            .padStart(2, "0");

                        res = res.filter((e) => e.mapel_id === mapel_id);
                    }

                    self.data_chart_per_mapel = res;
                })
                .finally(() => {
                    self.loading_per_mapel = false;
                });
        },

        delay(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },

        mapelName(mapel_id) {
            const mapel_name = this.mapelList.find(
                (e) => e.id === mapel_id
            ).nama;
            return mapel_name;
        },
    },
};
</script>



// WEBPACK FOOTER //
// ConsulActivity.vue?0026cc08